import { fetchWards } from "api/counsilors";
import WardsDetails from "components/WardsDetails";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AllWardsTable from "themes/elements/Table/AllWardsTable";
import { isPermit } from "utils/permissionCheck";
import {
  setLoading,
  setSelectedUser,
  setTotalPageNo,
  setWardsCurrentPageNo,
} from "./allWardsSlice";

function AllWards() {
  const dispatch = useDispatch();
  const [filterRegion, setFilterRegion] = useState(null);
  const [filterWard, setFilterWard] = useState(null);
  const [filterCouncillor, setFilterCouncillor] = useState(null);
  const [details, setDetails] = useState(false);
  const [filterTerm, setFilterTerm] = useState();
  const isFirstLoad = useRef(true);

  const columnData = [
    {
      title: "REGION",
      key: "region_name",
      filter: "searchTitle",
      width: 246,
    },
    {
      title: "WARD NO.",
      key: "ward",
      filter: "searchNumber",
      width: 246,
    },
    {
      title: "COUNCILLOR",
      key: "councillor",
      filter: "searchCouncillor",
      width: 332,
    },
    {
      title: "councillor term",
      key: "term",
      filter: "datePicker",
      width: 332,
    },
  ];

  const [recipientsData, setRecipientsData] = useState([]);
  const { isLoading, currentPageNo, totalPageNo, wards, selectedUser } =
    useSelector((state) => state.wards);

  const loadWards = async () => {
    dispatch(setLoading(true));

    try {
      const params = {
        page: currentPageNo,
        perPage: 10,
        councilorName: filterCouncillor && filterCouncillor,
        regionName: filterRegion && filterRegion,
        wardNo: filterWard && Number(filterWard),
      };
      if (filterTerm && filterTerm.length === 2) {
        params.termStartDate = reformatDate(filterTerm[0]);
        params.termEndDate = reformatDate(filterTerm[1]);
      }
      const res = await fetchWards(params);
      if (res?.meta) {
        if (currentPageNo === 1) {
          dispatch(setTotalPageNo(res.meta.last_page * 10)); // Changed to totalPages, if your API returns total pages directly, use that instead of last_page * 10
        }
        dispatch(setWardsCurrentPageNo(res.meta.current_page)); // Use currentPage directly if it's provided
      }
      const wardOptions = res?.wards?.map((ward) => ({
        region: `${ward?.region_id} `,
        councillor:
          ward?.first_name && ward?.last_name
            ? `${ward.first_name} ${ward.last_name}`
            : null,
        ward: Number(ward?.ward_code),
        term: ward?.term,
        ...ward,
      }));
      if (wardOptions?.length > 0) {
        setRecipientsData([...wardOptions]);
      } else {
        setRecipientsData();
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    dispatch(setWardsCurrentPageNo(1)); // Set the page number to 1
  }, [dispatch]); // Only run once on mount

  // Second effect: Wait for currentPageNo to be set to 1 before calling loadWards
  useEffect(() => {
    if (currentPageNo === 1 && isFirstLoad.current) {
      loadWards(); // Trigger the initial data load after currentPageNo is set
      isFirstLoad.current = false; // Set first load flag to false
    }
  }, [currentPageNo]); // This effect runs when currentPageNo changes

  // Effect for subsequent changes (pagination and filters)
  useEffect(() => {
    if (!isFirstLoad.current) {
      loadWards();
    }
  }, [currentPageNo, filterTerm, filterWard, filterCouncillor, filterRegion]);

  const reformatDate = (dateStr) => {
    const parts = dateStr.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // Concatenate in the new order
  };

  return (
    <div className="page-wrapper flex flex-column gap-4">
      {details ? (
        <WardsDetails setDetails={setDetails} />
      ) : (
        <>
          <h2 className="page-title">All wards</h2>
          {isPermit(5, "view") && (
            <AllWardsTable
              isLoading={isLoading}
              column={columnData}
              data={recipientsData}
              filterRegion={filterRegion}
              setFilterRegion={setFilterRegion}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
                setDetails(true);
              }}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
            />
          )}
        </>
      )}
    </div>
  );
}

export default AllWards;
